module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "images/ch2.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_vm._v("M")]), _vm._v("om stifles her own scream as Niall chuckles and puts a hand on her shoulder. “Dunna worry, darlin’. ’Tis nothing more than those crazy-eyed peacocks,” he says, pointing. “See there? They love nothing better than to roost in the trees.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I follow Niall’s gaze, and find several blue-bodied peacocks settled into their roosts, high in an aged oak. One stretches its neck and cries out. I swear, it sounds "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exactly")]), _vm._v(" like a woman’s scream. My teeth chatter, and I rub my arms through my heavy sweater.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("“Let’s go inside,” says Niall. He and Mom turn and I follow, glancing up at the castle’s imposing facade. A slight movement catches my eye in a small window close to the top of the castle wall. It’s high enough up that I ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("can’t tell if someone is standing there. I squint, trying to see through the fading light and thick mist. But I see nothing.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("feel")]), _vm._v(" something, though. As if eyes are on me, watching my every move.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The feeling doesn’t go away once I’m inside the castle. Is someone behind me? I freeze, still as death, and glance over my shoulder. Nothing. Slowly, I exhale. I’m probably just letting my imagination run crazy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stone walls and black wooden rafters make up the enormous great hall. There are three circular chandeliers made of old deer antlers, and a fireplace large enough to walk into. Brass sconces light the hall with a blushed amber glow. At the far end is a large staircase, with one of those menacing gargoyles perched on top of the bannister. There are some other curiosities I’ll have to explore later, things I’ll want to see up close, like the tall, dusty suit of armor in the corner.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Very different from the small two-bedroom carriage-house apartment Mom and I shared in Charleston. I glance around and swallow a lump of apprehension.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like it or not, this is home sweet home.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Niall turns to me. “Ivy, your chamber is on the third ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("floor, last door on the right. You’ve the place to yourself up there, and it’s equipped with Wi-Fi.” He tells Mom, “Our chamber is on the second floor, love. Grandmother’s is on the first.”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At least I’m far from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mom beams at me. “Isn’t this great, Ivy? I already love it, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I give Mom a smile, although it feels about as fake as Elizabeth’s looked. “Sure, Mom,” I say. I don’t tell her that my stomach is full of rabid butterflies. Or that I wish Niall would at least show me to my room. I guess he figures I’m mature and can handle it myself. And I can. I will.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mom waves. “I’ll see you in a bit.” Then Niall whisks her off to show her the kitchen and introduce her to the staff.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I sigh, sling my violin case higher, and start up the stairs. On my way, I get a good look at the ghoulish gargoyle. Its face, fanged and misshapen, stares right at me.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("The higher I climb, the darker and colder it becomes, and by the time I reach the third floor, only the scant yellowish light from the wall sconces shines a path across the hardwood hall. A faded rug stretches the length of the ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("corridor. Against the wall halfway to my room sits a lone straight-backed wooden chair. The silence unnerves me.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the last door on the right, I stop, turn the brass handle, and throw open the heavy oak.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My new room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I walk in and gape at a space that’s easily as large as our old apartment. My bags have already been brought up and placed neatly against the wall. A mahogany armoire stands in the far corner, and a small writing desk and lamp sit beside the bed. At the foot of the bed is a medieval-looking wooden chest, covered in etchings and bands of iron.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I walk over to the massive bed. The mattress comes up to my waist, and the four mahogany posts nearly reach the ceiling. A gray plaid curtain made of wool hangs on a wooden rod that circles the bed. I can close myself in when I sleep if I want.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I guess it’s nice to have the privacy, alone on the third floor. But then my imagination runs wild again. Someone could slip in at any time and kidnap me. Murder me in my sleep. And no one would even hear me if I screamed….")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("I try to shake off these thoughts. I walk over to the big picture window beside the fireplace. The same scratchy-looking gray plaid wool not only covers the window seat ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("but is also used for drapes. I push the curtains aside and peer out.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The shadowy cliffs completely drop off into the sea, eerily beautiful. An entire panorama of the west side of Glenmorrag’s grounds can be seen. At the farthest corner, I make out what looks to be a stone ruin, right on the property. Intriguing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“ ’Tis the old rectory. A fine, cavernous grotto to explore,” a clipped, proper voice says, making me jump.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I spin around to see an old man in a pressed gray suit standing in my doorway. He was one of the servants who took our luggage from the car.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“ ’Twas built in 1789,” he continues, nodding out the window toward the ruin. He must notice I still looked startled by his presence, because one corner of his mouth lifts, and he gives a short bow. “I am Jonas, young lady, and I am Glenmorrag’s steward. Let me know if I can be of any assistance at all. Supper will be served in fifteen minutes. And the toilet — err, the bathroom, as you Yanks call it — is just across the hall. There’s a pantry within. It should contain all necessities.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks, Jonas,” I say, relaxing. He seems friendly. Almost grandfatherly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("He winks, and flicks something from his sleeve. “Lady Elizabeth doesn’t fancy waiting. She gets a bit cross when her tummy rumbles.”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I nod. “I can imagine that.” I seriously doubt a rumbling tummy is the only thing that makes Elizabeth cross.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jonas gives the vaguest of grins, then turns and disappears out the door. I decide I like him. He has a twinkle in his eye that screams rebel to me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I quickly freshen up in the bathroom, then make my way back down the dim corridor and downstairs for supper.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’m not sure what I was expecting to find in the dining room, but it wasn’t a long, formal table set with silver and fine china. Niall and Mom are already seated, and Mom gives me a comforting smile. Grandmother MacAllister watches me closely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can take your place there,” she says, inclining her head to a setting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks.” I tuck my hair behind my ear and glance around. Four servers are standing behind the table in a line, waiting. For me, I suppose. I can’t believe there is so much fuss over four people eating dinner.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Once I’m seated, the food is served: first a course of bland pea soup, followed by beef tips, seasoned potatoes, and sautéed vegetables. It’s fine, but I want nothing more than to sit with Mom in our tiny kitchen in Charleston and eat a burger and fries. All this formal stuff is too much.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I peer at Elizabeth over the rim of my glass. Her skin is so thin and pale, blue veins peek out from the white face powder she’s applied liberally. She has on a dress and heels. On her index finger I notice an elaborate ruby ring in a square setting, set in gold. It’s the deepest red I’ve ever seen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I have on the same outfit I traveled in: big sweater, skinny jeans with holes in the knees, sneakers. I can’t help but wonder if Elizabeth will eventually insist I dress for dinner. I hope not.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is your room sufficient, Ivy?” Niall asks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I nod, surprised Niall’s even speaking to me. “Big,” I say after I’ve finished chewing a mouthful of potatoes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Aye,” he answers. A moment later he adds, “There’s an enormous maze out back, in the gardens, that you might like.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’m not sure what to say, so I nod. “Cool.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Elizabeth meticulously sets her fork and knife aside, ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("wipes her mouth with the cloth napkin, and turns toward me. I steel myself.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There are rules here, young lady,” Elizabeth begins. “Rules which you will be expected to obey.” Her frosty gaze locks onto me. “For one, holes in your clothes at the family table are unacceptable.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Knew it. I shoot a glance at Mom, who looks troubled by this statement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And it’s more than clear that you need quite a bit of etiquette training,” Elizabeth adds. Her eyes harden. “Sit up straight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I don’t move. The entire room goes silent as a graveyard. I don’t even know how to respond.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Gran,” Niall says to Elizabeth, surprising me again. “ ’Tis no way to start out with Ivy here. Times have changed, you know,” he coaxes. “Ivy’s fine. Now,” he says, changing the subject, “tell my new bride here of your first days at the castle, aye?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I look gratefully at Niall, and my mom eases a pleading gaze my way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I know Mom. She doesn’t like how Elizabeth just spoke to me, but she doesn’t want to make enemies with her, either.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("Niall’s question seems to do the trick. The MacAllister matriarch turns her attention to Mom and Niall. I stifle a sigh of relief.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A genuine smile touches Elizabeth’s lips. “ ’Twas the grandest day of my life, the day I first set foot in Glenmorrag,” she says. “The village, with its cobblestones and stone walls and little shops. And this place.” She glances around. “I … couldn’t believe it was mine. The castle needed a woman’s touch, that was for certain. I replaced the tartan fabrics, hired some help, and had it cleaned from top to bottom. At the same time, your grandfather’s distilleries began to do exceedingly well. That’s when I …”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her voice trails off. And her eyes harden.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Aye, Grandmother?” Niall urges.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nothing. ’Twas a long time ago.” Elizabeth then picks up her fork and knife, and begins to eat, ignoring us all. Niall looks at Mom and gives a slight shrug. Weird. Could she be senile? I wonder. She "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" really old.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By this time I’ve eaten my fill, so, in my most polite voice, I excuse myself to head back upstairs. I can only take so much of Elizabeth. Mom seems to understand — she blows me a kiss and wishes me good night.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("The scream of the wind pushes at the cracks of the castle walls as I hurry to my new room. Once inside, with the door closed, I breathe easier. I decide to unpack before bed. Maybe I’ll feel more settled then.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As I open the armoire, I think about starting at my new school on Monday. I wonder how it’s going to be. I’ve gone to school with the same group of kids most of my life. Now I’ll be joining a class in the middle of their semester, or whatever it’s called here. Everyone already has friends. I’m American, so that will probably make me a point of interest. Who knows? I do know I have to wear a uniform, which really bites.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’m folding my last sweater when the hairs on the back of my neck turn stiff. Suddenly, I hear the moan of a bow being dragged across the strings of a violin. I whip around.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My violin is suspended in midair. I feel my knees go weak and I try to scream but nothing comes out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My violin is being played in midair by … no one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I blink. Just that fast, the instrument flies and lands on the bed. I let out a small shriek and rush over to it. I grab the violin and bow and hug them to my chest as I frantically scan the room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("The weighty presence of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("something")]), _vm._v(" lingers, but the room is empty. I even drop to my knees and peek underneath the bed.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nothing is there. No one. Not even a dust bunny.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But I know what I saw. I jump up and head for the door. I have to tell Mom what just happened. As I fling open the door, though, I find Jonas standing there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Miss Ivy, is there something the matter?” he asks. “I heard a scream.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I —” I begin, and glance behind me, then back toward Jonas. “I … s-saw something weird,” I finally stammer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A look of understanding crosses Jonas’s face but it’s quickly replaced by one of concern. “What was it?” he asks. He peers over my shoulder into my room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I stare at him, unsure of what to say. If I tell him what I saw, I’ll sound like a lunatic. If I tell "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mom")]), _vm._v(" what I saw, I will as well. She’ll think I’m acting out, trying to find an excuse to go home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you sure you’re not just overly tired, miss?” Jonas asks. “Jet lag can do strange things to a person.” He gives me a reassuring smile. “I’ll fix you a nice cup of hot tea and bring it straightaway. Tea fixes everything, you know.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("I smile back, feeling my heart rate slow down a bit. “Sure, that sounds great.” Maybe he’s right. Maybe I am just jet-lagged.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As I wait for Jonas to return with the tea, I hover by the door, still a little afraid to go back fully inside the room. But my violin and bow lay innocently on my bed, and the eerie feeling that was here earlier seems to have lifted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suddenly, I feel a deep sense of emptiness. It’s not like me to wallow in self-pity. But this new situation is making me realize how utterly alone I am. Mom and Niall are wrapped up in each other. My dad is gone. I have no siblings, grandparents, or even aunts and uncles that I’m close to. My step-grandmother has apparently decided to hate my guts. My friends back home — if I can even call them friends anymore — are an ocean away. I fight the urge to cry. Jonas will be back soon and he doesn’t need to see me sniffling and sobbing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("Within a few moments, he returns with a tray, and on it a pot of steaming-hot tea, a flowery cup and saucer, sugar cubes, cream, and a tiny little spoon. Three thick, rectangular cookies sit upon a frilly napkin. “Here you are, young lady,” he says, placing the tray on my bedside ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("table. “Tea, and some shortbread to go with it. If you should need anything else, my chambers are behind the kitchen downstairs.”")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you,” I say, realizing Jonas is the closest thing I have to a friend right now. “I really appreciate it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My pleasure,” he responds, then quietly leaves me alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As I sip the tea and chomp on the cookies — shortbread, I remind myself — I do start to feel better. I even get brave enough to walk over to my violin and bow and lift them up, feeling their familiar weight. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("It was just your imagination")]), _vm._v(", I tell myself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I take my violin to the window and find a comfortable spot on the window seat. Outside, the Highlands are covered in inky darkness. With a sigh, I drag my bow over the strings and begin to play, improvising. The melody that comes out is soft, yet powerful. The melancholy sound fits my mood as I gaze out into the shadows of the moors.")])])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17a09214","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545539364_ch002.vue
// module id = 72
// module chunks = 0